var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100vh" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.onCancel()
                },
              },
            },
            [_c("w-fa", { staticClass: "mts mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c("app-edit-product", {
        ref: "AppEditProduct",
        attrs: {
          value: _vm.product,
          "is-info": _vm.isInfo,
          "show-edit-composition": "",
          "drawer-button-disabled": "",
        },
        on: {
          cancel: function ($event) {
            return _vm.onCancel()
          },
          clearChanges: function ($event) {
            return _vm.clearChanges()
          },
          delete: function ($event) {
            return _vm.onDeleted()
          },
          input: function ($event) {
            return _vm.onInput($event)
          },
          saved: _vm.saved,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }